const greetings = [
  "market.greetings.readyToShop",
  "market.greetings.findSomethingUnique",
  "market.greetings.spendTimeWisely",
  "market.greetings.somethingInteresting",
  "market.greetings.lookingForTreasures",
  "market.greetings.bestDeals",
  "market.greetings.cartIsHungry",
  "market.greetings.shopLikeHero",
  "market.greetings.freshDeals",
  "market.greetings.goldWellSpent",
];

export { greetings };
